import { getCode }  from '../../../modules/get_code'

export default (data) => {

  const r = {}
  r.data = data;
  const init = () => {
    console.log('buildResult', data)
    r.root = document.getElementById('result');
    if (!r.root) {
      return;
    }
    BuildRefundResultList(r.data.order);
    buildRefundRaceVideo(r.data.movie);
    buildRefundPaymentTable(r.data.payment);

    // レース結果エリアの表示復帰
    r.root.classList.add('_visibled');
    // アンカーリンクエリアの表示復帰
    document.getElementById('anchor').classList.remove('_hidden');
  }

  // 出走結果リストの作成
  const BuildRefundResultList = (orderData) => {
    if (!orderData) {
      r.root.querySelector('.le-round__result-detail').remove();
      return;
    }
    // 出走結果リスト取得、リストアイテムの初期化
    const rankClassName = ['_first', '_second', '_third'];
    const resultList = document.querySelector('.le-round-result__list')
    const resultListItem = resultList.firstElementChild;
    resultListItem.classList.remove(...rankClassName);

    // 車番カラーリスト
    const rowColors = [
      '_one', '_two', '_three', '_four', '_five', '_six'
    ]

    const fragment = document.createDocumentFragment();
    orderData.orderNum.forEach(rowData => {
      // console.table(rowData)
      const cloneResultListitem = resultListItem.cloneNode(true);
      // 車番カラー設定
      cloneResultListitem.classList.add(rowColors[rowData.bike_no - 1]);
      // 着順による色設定
      if (rowData.race_rank && rowData.race_rank <= 3) {
        cloneResultListitem.classList.add(rankClassName[rowData.race_rank - 1]);
      }

      // 出走結果失格による処理の切り替え
      // race_rank == null : レース結果データ挿入前：レース結果未確定 → フィルタリングされていて、dataListにデータがない為そもそもが表示されない：全選手表示されない
      // race_rank == 0 : レース結果データ挿入後：レース結果確定 → 棄権・失格者は 0 で返ってくる為、表示内容を切り替え
      if (rowData.race_rank == 0) {
        cloneResultListitem.classList.add('is-disqualification');
        // const disqualificationCell = createDisqualificationCell();
        // cloneResultListitem.appendChild(disqualificationCell);
        cloneResultListitem.querySelector('.le-round-result__pos').textContent = 'ー';
      } else {
        cloneResultListitem.querySelector('.le-round-result__pos').textContent = rowData.race_rank;
      }
      cloneResultListitem.querySelector('.le-round-result__no').textContent = rowData.bike_no;

      // 共通表示設定
      cloneResultListitem.querySelector('.le-round-result__name').textContent = rowData.name;
      cloneResultListitem.querySelector('.le-round-result__personal-age').textContent = rowData.age;
      cloneResultListitem.querySelector('.le-round-result__personal-country').textContent = rowData.country || 'ー';
      cloneResultListitem.querySelector('.le-round-result__time').textContent = rowData.race_time || 'ー';

      // 着差設定
      if (rowData.race_difference_code) {
        cloneResultListitem.querySelector('.le-round-result__sec-num').textContent = getCode('raceDifference', rowData.race_difference_code).name;
        cloneResultListitem.querySelector('.le-round-result__sec-num').classList.add('u-fw-bold');
      } else {
        cloneResultListitem.querySelector('.le-round-result__sec-num').textContent = 'ー';
      }
      cloneResultListitem.querySelector('.le-round-result__sec-unit').remove();

      // オッズ、人気順設定
      cloneResultListitem.querySelector('.le-round-result__odds-num').textContent = rowData.odds || '-';
      cloneResultListitem.querySelector('.le-round-result__rate-num').textContent = rowData.rate || '-';

      // 選手画像設定と画像の読み込みエラー処理
      const panel = cloneResultListitem.querySelector('.le-round-result__panel');
      panel.dataset.modalContent = `${panel.dataset.modalContent}${rowData.playerId}`;
      panel.href = `/player/detail/?player_id=${rowData.playerId}`;
      const playerImg = cloneResultListitem.querySelector('.le-round-result__panel-img');
      const playerImgPath = `${window.pist6.imgOrigin}/player_card/${rowData.playerId}/1384x1840.jpg`;
      playerImg.onerror = () => {
        playerImg.src = '/assets/images/common/card/img_card_front_noimage.jpg';
      }
      playerImg.src = playerImgPath;
      playerImg.alt = rowData.name;

      fragment.appendChild(cloneResultListitem);
    });

    // 作成した出走表の挿入
    resultList.innerHTML = '';
    resultList.appendChild(fragment);
    // スケルトン表示の解除
    resultList.classList.remove('_skelton');
    resultList.removeAttribute('aria-hidden');

    // 注意書きテキストの生成
    buildRefundNote(orderData.noteText);

    console.log(`- exist ${resultList.closest('[id]').id}Area`)
  }

  // 出走結果失格のオーバーレイ要素作成
  // const createDisqualificationCell = () => {
  //   const cell = document.createElement('div');
  //   cell.classList.add('le-round-result__body-cell', '_disqualification')
  //   cell.textContent = `失格`;
  //   return cell;
  // }

  // 注意事項の表示処理
  const buildRefundNote = (noteText) => {
    if (!noteText) {
      document.querySelector('#result .le-round-result__note').remove();
      return;
    }

    const note = document.querySelector('#result .le-round-result__note');
    note.querySelector('.le-round-result__note-txt').textContent = noteText;

    note.classList.remove('_skelton');
    note.removeAttribute('aria-hidden');
  }

  // レース映像・インタビュー映像の設定
  const buildRefundRaceVideo = (movieData) => {
    if (!movieData) {
      r.root.querySelector('.le-round__result-movie').remove();
      return;
    }

    const movieList = document.querySelector('.le-movie__list');
    const movieListitems = movieList.querySelectorAll('.le-movie__list-item');

    movieListitems.forEach(listitem => {
      const sectionArea = listitem.querySelector('.le-movie__section');
      const sectionName = sectionArea.dataset.section;
      const movieContainer = listitem.querySelector('.le-movie__body');
      const movieItem = movieContainer.firstElementChild;

      const fragment = document.createDocumentFragment();

      if (movieData[sectionName].length > 0) {
        movieData[sectionName].forEach(movieId => {
          const cloneMovieitem = movieItem.cloneNode(true);
          cloneMovieitem.innerHTML = `<iframe class="le-movie__entity" width="560" height="315" src="https://www.youtube.com/embed/${movieId}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
          fragment.appendChild(cloneMovieitem);
        });
        movieContainer.innerHTML = '';
        movieContainer.appendChild(fragment);
      } else {
        listitem.remove();
      }
    })

    console.log(`- exist ${movieList.closest('[id]').id}Area`)
  }

  // 払戻金表の作成
  const buildRefundPaymentTable = (refundData) => {
    if (!refundData) {
      r.root.querySelector('.le-round__result-refund').remove();
      return;
    }

    const refundTable = r.root.querySelector('.le-refund__table');
    const refundTableRows = refundTable.querySelectorAll('.le-refund__table-row');
    refundTableRows.forEach(row => {
      const voteType = row.dataset.type;
      row.querySelector('.le-refund__table-order').innerHTML = refundData.result[voteType].order;
      row.querySelector('.le-refund__table-refund').innerHTML = refundData.result[voteType].refund;
    })

    // 注意書きテキストの生成
    buildRefundPaymentNote(refundData.notes);

    console.log(`- exist ${refundTable.closest('[id]').id}Area`)
  }
  // 払戻金に関する注意事項の作成
  const buildRefundPaymentNote = (notesData) => {
    const paymentNote = document.querySelector('.le-refund__note');
    const isExistNote = Object.keys(notesData).filter(key => notesData[key]).length > 0;
    if (isExistNote) {
      const noteTexts = {
        "isSpecial": '※ 特払いがあります。',
        "isReturn": '※ 返還があります。'
      }

      const noteTxt = paymentNote.querySelector('.le-refund__note-txt');
      const fragment = document.createDocumentFragment();
      Object.keys(notesData).filter(key => notesData[key])
        .forEach(key => {
          const cloneNoteTxt = noteTxt.cloneNode();
          cloneNoteTxt.textContent = noteTexts[key];
          fragment.appendChild(cloneNoteTxt);
        })

      paymentNote.innerHTML = '';
      paymentNote.appendChild(fragment);

      paymentNote.classList.remove('_skelton');
      paymentNote.removeAttribute('aria-hidden');
    } else {
      paymentNote.remove();
    }
  }

  init();
}
